// js
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';


const RollUpOverviewStatPPTX = ({ label, value, boldValue }) => (

  <div className={
      classnames({
        'analytics__roll-up-overview-stat-pptx': true,
        'analytics__roll-up-overview-stat-pptx--bold': boldValue
      })
  }>
    <div className='analytics__roll-up-overview-stat-pptx__value'>
      {value}
    </div>
    <div className='analytics__roll-up-overview-stat-pptx__label'>
      {label}
    </div>
  </div>
);

RollUpOverviewStatPPTX.defaultProps = {
  boldValue: false
};

RollUpOverviewStatPPTX.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  boldValue: PropTypes.bool
};

export default RollUpOverviewStatPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/RollUpOverviewStatPPTX.js